export function formatDate(date: Date): string {
  if (date.getTime() <= 0) return ''
  return date.toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  })
}
